import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatRadioModule } from '@angular/material/radio'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SelectSearchModule } from 'src/components/select-search/select-search.module'
import { ModalModule } from 'src/shared/modal'
import { AiCallFrequencyComponent } from './ai-call-frequency/ai-call-frequency.component'
import { CompanyContactFormComponent } from './company-contact-form.component'
import { CompanyContactFormService } from './company-contact-form.service'
import { LoginAllowedNotificationDialogComponent } from './login-allowed-notification-dialog.component'
import { LoginAllowedNotificationDialogService } from './login-allowed-notification-dialog.service'

@NgModule({
  declarations: [CompanyContactFormComponent, LoginAllowedNotificationDialogComponent],
  providers: [CompanyContactFormService, LoginAllowedNotificationDialogService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTooltipModule,
    ModalModule,
    SelectSearchModule,
    AiCallFrequencyComponent,
  ],
})
export class CompanyContactFormModule { }
